'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEvaluationDataWithException = getEvaluationDataWithException;
exports.getEmptyEvaluationData = getEmptyEvaluationData;

var _EvaluationData = require('./EvaluationData');

var _EvaluationData2 = _interopRequireDefault(_EvaluationData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEvaluationDataWithException(experimentId) {
    return new _EvaluationData2.default({
        entityId: 'UNAVAILABLE_ENTITY_ID',
        experimentKey: {
            experimentId: typeof experimentId === 'number' ? experimentId : 99991
        },
        experimentInstanceId: 0,
        bucket: {
            bucketValue: 0,
            calculationType: {
                typeIdentifier: 'F'
            }
        },
        entityType: {
            entityTypeName: 'UNAVAILABLE_ENTITY_TYPE'
        },
        value: 0,
        exception: true
    });
}

function getEmptyEvaluationData() {
    return new _EvaluationData2.default({});
}
//# sourceMappingURL=utils.js.map